'use strict';

import { CoreRepository } from '../CoreRepository';
import { GlobPlans } from '../../Entities/Glob/GlobPlans';
import { GlobPlansCollection } from '../../Collections/Glob/GlobPlansCollection';

export class GlobPlansRepository extends CoreRepository {
  public getGlobPlans(options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getGlobPlans(options).then((response) => {
      const collection = new GlobPlansCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new GlobPlans();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  /*
    public getGlobCompany(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getGlobPlans(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let GlobPlans = new GlobPlans();
            GlobPlans.hydrate(response);

            return GlobPlans;
        });
    }

    public createGlobPlans(payload: object = {}){  
    return this.webAPI.createGlobPlans(payload)
      .then( response => {
        let GlobPlans = new GlobPlans();
        GlobPlans.hydrate(response);

        return GlobPlans;
      });
    }

    public updateGlobPlans(payload: object = {}){  
        return this.webAPI.updateGlobPlans(payload)
        .then( response => {
            let GlobPlans = new GlobPlans();
            GlobPlans.hydrate(response);

            return GlobPlans;
        });
    }

    public removeGlobPlans( ){
        return this.webAPI.removeGlobPlans()
        .then( response => {
            return response;
        });
    }
    */
}
